import ApiSession from './session'
import ApiEvents from './events/events'
import ApiTask from './task'
import ApiTaskType from './task-type'
import ApiMyTime from './time-reports/my-time'
// @ts-ignore
import ApiPins from './pins'
import ApiProject from './project'
// @ts-ignore
import ApiTag from './tag'
// @ts-ignore
import ApiProjects from './projects'
import ApiMyWork from './my-work'
// @ts-ignore
import ApiStarred from './starred'
// @ts-ignore
import ApiCompany from './company/company'
// @ts-ignore
import ApiSupport from 'core/gd/api/support'
// @ts-ignore
import ApiEmail from './email'
// @ts-ignore
import ApiWorkload from './workload'
import ApiUser from './user'
// @ts-ignore
import ApiReminder from './reminder'
import ApiCustomFields from './custom-fields'
import ApiViews from './custom-view'
// @ts-ignore
import ApiGantt from './gantt'
// @ts-ignore
import ApiMeeting from 'core/gd/api/meeting'
import ApiMyAccount from './my-account/my-account'
// @ts-ignore
import ApiBigScreen from './big-screen'
// @ts-ignore
import ApiPrintToPdf from './print-to-pdf'
// @ts-ignore
import ApiTaskTable from './task-table'
// @ts-ignore
import ApiWiki from './wiki'
import ApiExport from './import-export/export'
import ApiImport from './import-export/import'
import ApiSearch from './search'
// @ts-ignore
import ApiChat from './chat'
// @ts-ignore
import ApiAttachment from 'core/gd/api/attachment'
import ApiRequestForm from './request-form'
import ApiAnalytics from './analytics'
import ApiProjectUser from './project-user'
import ApiBulkActions from './bulk-actions'
import ApiIntegrations from './integrations/integrations'
// @ts-ignore
import ApiRecent from "./recent"
import ApiShareView from "./share-view"
// import ApiNotes from "./notes"
import ApiExpenses from "./expenses"
// @ts-ignore
import ApiCRM from './clients'
import ApiDependency from "./dependency"
// @ts-ignore
import ApiLogs from "./logs"
// @ts-ignore
import ApiAutomations from "core/gd/api/automations"
import ApiTrash from "./company/trash"
// @ts-ignore
import ApiRecurrence from "./company/recurrence"
import ApiTaskMessage from "./task-message"
import ApiPortfolio from "./portfolio"
// @ts-ignore
import ApiNotifications from "core/gd/api/notifications"
import ApiGoal from "./goal"
import ApiOffice from "./office"
import ApiAttendance from "./attendance"

const Api = {
    Dependency      : new ApiDependency(),
    Session         : new ApiSession(),
    BigScreen       : new ApiBigScreen(),
    Events          : new ApiEvents(),
    Task            : new ApiTask(),
    TaskMessage     : new ApiTaskMessage(),
    TaskType        : new ApiTaskType(),
    MyTime          : new ApiMyTime(),
    MyAccount       : new ApiMyAccount(),
    Pins            : new ApiPins(),
    Project         : new ApiProject(),
    Tag             : new ApiTag(),
    Projects        : new ApiProjects(),
    ProjectUser     : new ApiProjectUser(),
    MyWork          : new ApiMyWork(),
    Starred         : new ApiStarred(),
    Company         : new ApiCompany(),
    Support         : new ApiSupport(),
    Email           : new ApiEmail(),
    Workload        : new ApiWorkload(),
    Reminder        : new ApiReminder(),
    User            : new ApiUser(),              // this is COMPANY USER !!!
    CustomFields    : new ApiCustomFields(),
    Views           : new ApiViews(),
    Gantt           : new ApiGantt(),
    // MenuSettings    : new ApiMenuSettings(),
    PrintToPdf      : new ApiPrintToPdf(),
    TaskTable       : new ApiTaskTable(),
    Wiki            : new ApiWiki(),
    Search          : new ApiSearch(),
    Chat            : new ApiChat(),
    Attachment      : new ApiAttachment(),
    RequestForm     : new ApiRequestForm(),
    Analytics       : new ApiAnalytics(),
    BulkActions     : new ApiBulkActions(),
    Integrations    : new ApiIntegrations(),
    Recent          : new ApiRecent(),
    ShareView       : new ApiShareView(),
    Meeting         : new ApiMeeting(),
    // Notes           : new ApiNotes(),
    Expense         : new ApiExpenses(),
    CRM             : new ApiCRM(),
    Logs            : new ApiLogs(),
    Automation      : new ApiAutomations(),
    Portfolio       : new ApiPortfolio(),

    // import export
    Export          : new ApiExport(),
    Import          : new ApiImport(),

    Trash           : new ApiTrash(),
    Recurrence      : new ApiRecurrence(),

    Notifications   : new ApiNotifications(),
    Goal            : new ApiGoal(),
    Office          : new ApiOffice(),
    Attendance      : new ApiAttendance(),

    SharedViewApp   : {} as any, // exists in shared view api
    SharedView      : {} as any, // exists in shared view api
}

export default Api
